"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppUrlProvider = exports.AppUrlsSchema = void 0;
const zod_1 = require("zod");
exports.AppUrlsSchema = zod_1.z.object({
    teacher: zod_1.z.string().url().min(1),
    admin: zod_1.z.string().url().min(1),
    student: zod_1.z.string().url().min(1),
    search: zod_1.z.string().url().min(1),
    site: zod_1.z.string().url().min(1),
});
class AppUrlProvider {
    constructor(appUrls) {
        this.appUrls = appUrls;
    }
    get teacherUrl() {
        return new URL(this.appUrls.teacher);
    }
    get adminUrl() {
        return new URL(this.appUrls.admin);
    }
    get studentUrl() {
        return new URL(this.appUrls.student);
    }
    get searchUrl() {
        return new URL(this.appUrls.search);
    }
    get siteUrl() {
        return new URL(this.appUrls.site);
    }
    agreementToBeSignedUrl({ agreementId, secret, proposalId }) {
        return new URL(`${this.teacherUrl.toString()}app/agreement/GDPR/${agreementId}/${secret}/${proposalId}`);
    }
    signedAgreementUrl({ agreementId, secret, document }) {
        return new URL(`${this.teacherUrl.toString()}app/agreement-documents/${document}/${agreementId}/${secret}`);
    }
    keepAccountUrl() {
        return new URL(`${this.teacherUrl.toString()}app/account/profile`);
    }
    emailVerificationUrl({ token, language }) {
        return new URL(`${this.searchUrl.toString()}${language}/register/verify-email?token=${token}`);
    }
    directLoginUrl({ token, language }) {
        return new URL(`${this.teacherUrl.toString()}app/directLogin?token=${token}&language=${language}`);
    }
    forgotPasswordUrl(language) {
        return new URL(`${this.searchUrl.toString()}${language}/forgot-password`);
    }
    newMagicLinkUrl(language) {
        return new URL(`${this.searchUrl.toString()}${language}/magicLink`);
    }
    lessonModuleDirectLinkUrl({ groupId, lessonModuleId }) {
        return new URL(`${this.studentUrl.toString()}modules/${groupId}/${lessonModuleId}`);
    }
    teacherGroupDirectLinkUrl(groupId) {
        return new URL(`${this.teacherUrl.toString()}app/explorer/groups/${groupId}`);
    }
}
exports.AppUrlProvider = AppUrlProvider;
//# sourceMappingURL=app-url-provider.js.map